import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";

import AlertWrapper from "./components/AlertWrapper/AlertWrapper";
import "./index.css";
import { applyConsoleMethodsPatch } from "./helpers/consoleMethodsPatch";

// applyConsoleMethodsPatch();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <div className="notifications top-right">
        <AlertWrapper />
      </div>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// ReactDOM.render(app, document.getElementById('root'));

// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//       navigator.serviceWorker.register('./service-worker.js').then(registration => {
//         console.log('SW registered: ', registration);
//       }).catch(registrationError => {
//         console.log('SW registration failed: ', registrationError);
//       });
//     });
//   }
